<template>
	<div>
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<FormItem prop="trackName" label="充电站:" :label-width="60">
				<Select placeholder="站点列表" style="width: 120px;" v-model="formInline.StationId">
					<Option :value=0>全部</Option>
					<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">
						{{item.StationName}}
					</Option>
				</Select>
			</FormItem>
			<FormItem prop="trackName">
				<Input type="text" style="width: 180px;" v-model="formInline.OccupyOrderNo" placeholder="占位单号">
				<span slot="prepend">占位单号</span>
				</Input>
			</FormItem>
			<FormItem label="选择时间" :label-width='70'>
				<DatePicker style="width: 210px;" type="daterange" format="yyyy-MM-dd" placeholder="Select date"
					v-model="formInline.TimeRange" @on-change="handleChange"></DatePicker>
			</FormItem>
			<FormItem>
				<Input type="text" style="width: 150px;" v-model="formInline.PhoneNo" placeholder="会员手机">
				<span slot="prepend">会员手机</span>
				</Input>
			</FormItem>
			<FormItem>
				<Input type="text" style="width: 150px;" v-model="formInline.EquipmentNo" placeholder="设备编号">
				<span slot="prepend">设备编号</span>
				</Input>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSearch('formInline')" v-if="hasWidgets('search')">查询</Button>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="exportFile" v-if="hasWidgets('export')">导出文件</Button>
			</FormItem>
		</Form>
		<Table :columns="tableColumns" :data="tableData" :height="tableHeight" ref="OccupyOrder"></Table>
		<MyPage ref="sonPage" :param="pageParam" :url="getOccupyOrderUrl" @listData='getTableData'></MyPage>
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import expandRow from './OccupyOrderExpend.vue';
	import webapi from '../../../webapi.js';
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				getOccupyOrderUrl: webapi.base_api_url + '/Order/GetOccupyOrder',
				loadingStatus: false,
				//model表单
				params: "", //table 传参
				//选择展示的充电站
				tableHeight: "650",
				modal: {
					Title: "设备信息添加",
					type: "addDevice"
				},
				BreadcrumbList: ['订单记录', '>>', '占位订单'],
				formInline: {
					StationId: 0,
					OccupyOrderNo: '',
					TimeBegin: dateFormat.formatDate(new Date(new Date().getTime() - 1000 * 60 * 60 * 24), 'yyyy-MM-dd'),
					TimeEnd: dateFormat.formatDate(new Date(), 'yyyy-MM-dd'),
					TimeRange: [new Date(new Date().getTime() - 1000 * 60 * 60 * 24), new Date()],
					EquipmentNo: '',
					PhoneNo: '',
				},
				//table标题数据
				tableColumns: [{
						type: 'expand',
						width: 50,
						render: (h, params) => {
							return h(expandRow, {
								props: {
									row: params.row
								}
							})
						}
					}, {
						title: '占位单号',
						key: 'OccupyOrderNo',
						width: 180
					}, {
						title: '订单时间',
						key: 'CreateTime',
						width: 110
					}, {
						title: '订单类型',
						key: 'OrderType',
						minWidth: 100,
						render: (h, params) => {
							return h('div', params.row.OrderType == 1 ? '带地锁' : params.row.OrderType == 2 ? '不带地锁' : '')
						}
					},
					{
						title: '订单状态',
						key: 'IsSettled',
						minWidth: 100,
						render: (h, params) => {
							return h('div', params.row.IsSettled ? '已结算' : '未结算');
						}
					}, {
						title: '地锁编码',
						key: 'LockNo',
						minWidth: 100,
					},
					{
						title: '降锁时间',
						key: 'ParkingLockDroppingTime',
						minWidth: 100,
					},
					{
						title: '升锁时间',
						key: 'ParkingLockRaisingTime',
						minWidth: 100,
					},
					{
						title: '车辆入位时间',
						key: 'CarEnterTime',
						minWidth: 100,
					},
					{
						title: '车辆出位时间',
						key: 'CarLeaveTime',
						minWidth: 100,
					},
					{
						title: '占位时长(分钟)',
						key: 'OccupyDuration',
						minWidth: 100,
					},
					{
						title: '免费时长(分钟)',
						key: 'FreeDuration',
						minWidth: 100,
					},
					{
						title: '累计充电时长(分钟)',
						key: 'ChargeDuration',
						minWidth: 100,
					},
					{
						title: '占位费金额(元)',
						key: 'OccupyAmount',
						minWidth: 100,
					},
					{
						title: '手动减免金额(元)',
						key: 'ManualDerateAmount',
						minWidth: 100,
					},
					{
						title: '会员手机号码',
						key: 'PhoneNo',
						minWidth: 120,
					},
					{
						title: '会员名称',
						key: 'MemberName',
						minWidth: 100,
					},
					{
						title: '车牌号',
						key: 'CarNo',
					},
					{
						title: 'VIN',
						key: 'VIN',
					},
					// {
					// 	title: '枪编号',
					// 	key: 'ConnectorNo',
					// 	minWidth: 120,
					// },
					{
						title: '站点名称',
						key: 'StationName',
						minWidth: 100,
					}
				],
				//导出专用
				exportColumns: [{
						title: '订单单号',
						key: 'OrderNo',
						width: 180
					}, {
						title: '订单时间',
						key: 'OrderTime',
						width: 110
					},
					{
						title: '订单来源',
						//key: 'TradeType',
						key: 'TradeTypeDesc',
						render: (h, params) => {
							return h('div', params.row.TradeTypeDesc);
						}
					},
					{
						title: '支付方式',
						key: 'PaymentWayDesc',
						minWidth: 100,
						render: (h, params) => {
							return h('div', params.row.PaymentWayDesc);
						}
					},
					{
						title: '订单状态',
						//key: 'OrderStatus',
						key: 'OrderStatusDesc',
						render: (h, params) => {
							return h('div', params.row.OrderStatusDesc);
						}
					},
					{
						title: '结算类型',
						//key: 'OrderStatus',
						key: 'SettleTypeDesc',
						render: (h, params) => {
							return h('div', params.row.SettleTypeDesc);
						}
					},
					{
						title: '结算时间',
						//key: 'OrderStatus',
						key: 'SettleTime',
						render: (h, params) => {
							return h('div', params.row.SettleTime);
						}
					},
					{
						title: '会员手机号码',
						key: 'MemberPhone'
					},
					{
						title: '会员名称',
						key: 'MemberName'
					},
					{
						title: '预付金额(元)',
						key: 'OrderAmount' //订单金额
					},
					{
						title: '充电总费用(元)', //
						key: 'ChargeCost'
					},
					{
						title: '优惠金额(元)',
						key: 'CouponAmount'
					},
					{
						title: '结算金额(元)',
						key: 'CouponCost'
					},
					{
						title: '优惠活动',
						key: 'CouponName'
					},
					{
						title: '枪编号',
						key: 'ConnectorNo'
					},
					{
						title: '站点名称',
						key: 'StationName'
					},
					{
						title: '开始时间',
						key: 'StartTime'
					},
					{
						title: '结束时间',
						key: 'EndTime'
					},
					{
						title: '充电电费(元)',
						key: 'ElecCost'
					},
					{
						title: '充电服务费(元)',
						key: 'ServiceCost'
					},
					{
						title: '充电电量(度)',
						key: 'ChargeKwh'
					},
					{
						title: '起始SOC(%)',
						key: 'BeginSoc'
					},
					{
						title: '结束SOC(%)',
						key: 'EndSoc'
					},
					{
						title: '充电时长',
						key: 'ChargeDurationDesc'
					},
					{
						title: '退款金额(元)',
						key: 'RefundAmount'
					},
					{
						title: '退款状态',
						key: 'RefundStatusDesc'
					},
					{
						title: '退款时间',
						key: 'RefundTime'
					},
					{
						title: '停止原因',
						key: 'TerminateReason'
					},
					{
						title: '车牌号',
						key: 'CarNo',
					},
					{
						title: 'VIN',
						key: 'VIN',
					},
				],
				tableData: []
			};
		},
		created() {
			const _this = this;
			// _this.tableHeight = window.innerHeight - 220;
			this.getTableHeight();
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.handleSearch();
		},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = {
					StationId: _this.formInline.StationId,
					OccupyOrderNo: _this.formInline.OccupyOrderNo,
					TimeBegin: _this.formInline.TimeBegin == '' ? '' : dateFormat.formatDate(
						new Date(_this.formInline.TimeBegin), 'yyyy-MM-dd'),
					TimeEnd: _this.formInline.TimeEnd == '' ? '' : dateFormat.formatDate(
						new Date(_this.formInline.TimeEnd), 'yyyy-MM-dd'),
					EquipmentNo: _this.formInline.EquipmentNo,
					MemberName: _this.formInline.MemberName,
					PhoneNo: _this.formInline.PhoneNo,
					CouponName: _this.formInline.CouponName,
					PaymentWay: _this.formInline.PaymentWay,
				}
				return param
			},
			//直接选属性
			...mapState({
				StationList: 'Stations'
			})
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			handleChange(date, type) {
				console.log("日期改变：", date, type);
				this.formInline.TimeBegin = date[0];
				this.formInline.TimeEnd = date[1];
			},
			exportFile: function() {
				this.$refs.OccupyOrder.exportCsv({
					filename: '充电订单',
					columns: this.exportColumns,
					data: this.tableData.map(k => {
						k.OrderNo = "\t" + k.OrderNo;
						k.OrderTime = '\t' + (k.OrderTime || '');
						k.StartTime = '\t' + (k.StartTime || '');
						k.EndTime = '\t' + (k.EndTime || '');
						k.RefundTime = '\t' + (k.RefundTime || '');
						return k;
					})
				})
			},
			getTableData: function(data) {
				console.log(data)
				this.tableData = data.Data.List
			},
			handleSearch: function() {
				if (!this.hasWidgets('search')) return;
				this.$refs.sonPage.getList();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 220 - (window.innerWidth < 1369 ? 60 : 0);
			}
		},
	}
</script>

<style>
</style>